import { jsx as e } from "react/jsx-runtime";
import y from "clsx";
import { forwardRef as h } from "react";
import { Pressable as x } from "../Pressable/index.js";
import o from "./IconButton.module.css.js";
import { Tooltip as L } from "../Tooltip/Tooltip.js";
import { LoadingSign as v } from "../../foundations/icons/LoadingSign/index.js";
const w = h(
  ({
    appearance: r = "secondary",
    size: a,
    ariaLabel: m,
    loading: i = !1,
    children: n,
    active: l,
    tooltipOverride: d,
    disableTooltipOnFocus: c,
    tooltipInPortal: p,
    tooltipPlacement: f,
    className: b,
    ...t
  }, u) => {
    const s = a ?? (r === "primary" ? "md" : "sm");
    return /* @__PURE__ */ e(
      L,
      {
        tooltip: d ?? m,
        disableOpenOnFocus: c,
        inPortal: p,
        placement: f,
        show: !i,
        children: /* @__PURE__ */ e(
          x,
          {
            className: y(
              o.container,
              {
                [o[s]]: s,
                [o[r]]: r,
                [o.active]: l,
                [o.isLoading]: i
              },
              b
            ),
            ref: u,
            "aria-label": m,
            disabled: "disabled" in t && t.disabled || i,
            ...t,
            children: i ? /* @__PURE__ */ e(v, { "aria-busy": "true", "aria-live": "polite", ariaLabel: "Loading" }) : n
          }
        )
      }
    );
  }
);
w.displayName = "IconButton";
export {
  w as IconButton
};
//# sourceMappingURL=IconButton.js.map
